const t = "styles-module__extra___l-A1f", e = {
  extra: t
};
export {
  e as default,
  t as extra
};
